<script setup lang="ts">
  import { ALLERGENS } from '@/const/allergens.const';
  import { IItem } from '@/interfaces/IItem';
  import { computed } from 'vue';

  const props = defineProps<{
    item: IItem;
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    max?: number;
  }>();

  const allergens = computed(() => {
    if (!props.item.allergens) return [];

    return ALLERGENS.filter(
      (allergen) => (props.item.allergens & allergen.id) === allergen.id
    );
  });

  const filteredAllergens = computed(() => {
    if (props.max) {
      return allergens.value.slice(0, props.max);
    }

    return allergens.value;
  });

  const sizes = {
    xs: 12,
    sm: 20,
    md: 24,
    lg: 28,
    xl: 32,
  };

  const size = computed(() => sizes[props.size]);
</script>

<template>
  <div class="allergens-container">
    <div
      v-for="allergen in filteredAllergens"
      :key="allergen.id"
      class="allergen"
      v-tooltip="allergen.name"
    >
      <v-img
        class="allergen-image"
        :src="allergen.picturePath"
        :alt="allergen.name"
        :width="size ?? 'md'"
        :height="size ?? 'md'"
        provider="cloudflare"
        loading="lazy"
      />
    </div>
    <span
      v-if="filteredAllergens.length !== allergens.length"
      class="allergen-more"
    >
      y {{ allergens.length - filteredAllergens.length }} más
    </span>
  </div>
</template>

<style scoped lang="scss">
  .allergens-container {
    @apply tw-flex tw-items-center tw-gap-1 tw-text-gray-500 tw-flex-none tw-flex-wrap;

    .allergen-more {
      @apply tw-text-xs;
    }
  }
</style>
